// extracted by mini-css-extract-plugin
module.exports = {"hero":"i_l","subtitle":"i_m"};